import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SidebarItemComponent } from '../sidebar/sidebar-item/sidebar-item.component';

@Component({
  selector: 'app-header',
  imports: [RouterModule, CommonModule, SidebarItemComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  isMenuOpen = false;

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
  }

  // Schließt das Menü wenn außerhalb geklickt wird
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    const button = target.closest('button');
    const isMenuButton =
      button && button.getAttribute('aria-label') === 'Menü öffnen/schließen';

    if (!isMenuButton && !target.closest('.mobile-menu') && this.isMenuOpen) {
      this.closeMenu();
    }
  }

  // Schließt das Menü wenn die Fenstergröße geändert wird (z.B. von mobil zu desktop)
  @HostListener('window:resize', ['$event'])
  onResize(): void {
    if (window.innerWidth > 768) {
      this.closeMenu();
    }
  }
}
